import { DonationFundPlatformTypeEnum } from '@graphql/generated-base';
import { DEFAULT_CURRENCY } from '@shared/utils/currency/constants';
import { getCurrencySymbolFromCurrencyCode } from '@shared/utils/currency/utils';
import type { AddCashFundDialogFields } from '..';
import type { PaymentMethodDisclaimerSignedMetadata } from '../AppPaymentDisclaimerDialog.controller';
import type { DonationFundInfoFragmentWithUrl } from '../../Catalog/components/ProductGrid/ProductGrid.controller';

export const getPaymentLink = (paymentMethod?: Maybe<DonationFundPlatformTypeEnum>, username?: Maybe<string>) => {
  switch (paymentMethod) {
    case DonationFundPlatformTypeEnum.cashapp:
      return `https://cash.app/${username}`;
    case DonationFundPlatformTypeEnum.paypal:
      return `https://paypal.me/${username}`;
    case DonationFundPlatformTypeEnum.venmo:
      return `https://venmo.com/u/${username}`;
    default:
      return '';
  }
};

export const getPaymentUsernameFormat = (paymentMethod?: Maybe<DonationFundPlatformTypeEnum>, currencyCode?: string) => {
  return `${paymentMethod === DonationFundPlatformTypeEnum.cashapp ? getCurrencySymbolFromCurrencyCode(currencyCode || DEFAULT_CURRENCY) : '@'}`;
};

type paymentData = Pick<AddCashFundDialogFields, 'paymentMethod' | 'username'>;

export const createPaymentMetadata = (values: paymentData): PaymentMethodDisclaimerSignedMetadata => ({
  paymentLink: getPaymentLink(values.paymentMethod, values.username),
  paymentMethod: values.paymentMethod as string,
  paymentUsername: values.username!,
});

export const getExistingPlatform = (values: paymentData, donationFundInfo: DonationFundInfoFragmentWithUrl | undefined) => {
  return donationFundInfo?.platforms.some(platform => platform.type === values.paymentMethod && platform.username === values.username);
};
